import { AdministrativeFlag, ContactAttempt, ContactMethod, PaymentOutcome } from '@repo/types';
import { SelectOption } from '@repo/ui';

export const CONTACT_METHOD_OPTIONS: SelectOption[] = [
    { value: ContactMethod.PHONE, label: 'Phone' },
    { value: ContactMethod.INTERNAL_EMAIL, label: 'Internal Email' },
    { value: ContactMethod.EXTERNAL_EMAIL, label: 'External Email' }
];

export const PAYMENT_OUTCOME_OPTIONS: SelectOption[] = [
    { value: PaymentOutcome.PROMISE_TO_PAY, label: 'Promise To Pay' },
    { value: PaymentOutcome.PAYMENT_ALREADY_ISSUED, label: 'Payment Already Issued' },
    { value: PaymentOutcome.PARTIAL_PAYMENT_ISSUED, label: 'Partial Payment Issued' },
    { value: PaymentOutcome.PAYMENT_SCHEDULED_INTERNALLY, label: 'Payment Scheduled Internally' }
];

export const CONTACT_RESULT_OPTIONS: SelectOption[] = [
    { value: ContactAttempt.SPOKE_WITH_CLIENT, label: 'Spoke With Client' },
    { value: ContactAttempt.NO_ANSWER, label: 'No Answer' },
    { value: ContactAttempt.LEFT_VOICEMAIL, label: 'Left Voicemail' },
    { value: ContactAttempt.EMAIL_SENT, label: 'Email Sent' }
];

export const ADMINISTRATIVE_ACTION_OPTIONS: SelectOption[] = [
    { value: AdministrativeFlag.UPDATED_CONTACT_NEEDED, label: 'Updated Contact Needed' },
    { value: AdministrativeFlag.CLIENT_REQUESTED_CALLBACK, label: 'Client Requested Call Back' },
    { value: AdministrativeFlag.ESCALATED_TO_ATTORNEY, label: 'Escalated to Attorney' },
    { value: AdministrativeFlag.ESCALATED_TO_LEADERSHIP, label: 'Escalated to Leadership' }
];
